// @ts-nocheck
import React, { useState } from "react";
import * as S from './styles';
import Title from 'components/Title';
import FileUpload from 'components/FileUpload';
import SuccessBaseCad from 'components/Alerts/SuccessBaseCad';
import { ErrorBaseCad } from 'components/Alerts/ErrorBaseCad';


const UpdateCad = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [fileResetTrigger, setFileResetTrigger] = useState(false);

  const handleCloseError = () => {
    setErrorMessage("");
    setIsErrorOpen(false);
    setFileResetTrigger((prev) => !prev);
  };

  return (
    <S.PageContainer>
      <Title
        titleText="Atualizar base do Cadastro Único"
        subtitleTexts={['Início', 'Atualizar base do Cadastro Único']}
      />
      <S.InstructionText>
        Envie um arquivo compactado (.zip) contendo apenas um arquivo (.csv), nomeado como <strong>”tab_cad.csv"</strong>.
      </S.InstructionText>

      {successMessage && (
        <SuccessBaseCad
          open={true}
          onClose={() => setSuccessMessage("")}
          alertText={successMessage}
        />
      )}

      {errorMessage && (
        <ErrorBaseCad
          open={isErrorOpen}
          message={errorMessage}
          handleClose={handleCloseError}
        />
      )}

      <S.PageContent>
        <FileUpload
          setSuccessMessage={setSuccessMessage}
          setErrorMessage={(message) => {
            setErrorMessage(message);
            setIsErrorOpen(true);
          }}
          resetFile={() => setFileResetTrigger((prev) => !prev)}
        />
      </S.PageContent>
    </S.PageContainer>
  );
};

export default UpdateCad;
